module.exports = __webpack_public_path__ + "img/46CASACCA-ROSA-SML-COLORI-LINO-STAMPE-LINO-PANTALONE-CAPRI-SMLXL-COLORI-LINO4.6e75b964.jpg";